import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import {
  Box,
  Divider,
  Heading,
  HStack,
  Pressable,
  Spacer,
  Stack,
  Text,
  useDisclose,
  VStack,
} from "native-base";
import { IoMdPerson } from "react-icons/io";
import { FaFacebookF } from "react-icons/fa";
import { FiFacebook, FiInstagram, FiYoutube } from "react-icons/fi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { RiTwitterXFill } from "react-icons/ri";
import { GoogleLogin } from "react-google-login";
import { FiMail } from "react-icons/fi";
import qs from "qs";
import classNames from "classnames";
import styles from "./styles.module.css";
import logo from "../../assets/images/logo_simple.png";
import routes from "../../routes";
import colors from "../../constants/colors";
import Modal from "../../components/modal";
import { StateContext, StatusContext } from "../../contexts";
import google from "../../assets/icons/google.svg";
import logoHola from "../../assets/images/logo_hola.svg";
import Image from "../../components/image";
import { isInIframe } from "../../utils";
import API from "../../api";

function MainLayout() {
  const location = useLocation();
  const state = useContext(StateContext);
  const status = useContext(StatusContext);
  const container = useRef();
  const {
    isOpen: isOpenSignUpDialog,
    onOpen: onOpenSignUpDialog,
    onClose: onCloseSignUpDialog,
  } = useDisclose();
  const { isOpen, onOpen, onClose } = useDisclose();
  const [isLoading, setIsLoading] = useState(false);
  const isEmbedded = useMemo(() => isInIframe(), []);
  const [email, setEmail] = useState("");
  const [isSending, setIsSending] = useState(false);

  useEffect(() => {
    if (container.current) {
      container.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location.pathname]);

  useEffect(() => {
    onCloseSignUpDialog();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const onFacebookSignUp = async () => {
    try {
      setIsLoading(true);
      if (window.FB) {
        const response = await new Promise((resolve) =>
          window.FB.login(resolve, { scope: "public_profile,email" }),
        );
        if (response.authResponse) {
          alert(
            `https://graph.facebook.com/me?fields=id,email,name,first_name,last_name&access_token=${response.authResponse.accessToken}`,
          );
          setIsLoading(false);
          onCloseSignUpDialog();
        } else {
          throw new Error("Error iniciando sesión, por favor intente de nuevo");
        }
      } else {
        throw new Error("Opción no disponible, por favor intente de nuevo");
      }
    } catch (error) {
      setIsLoading(false);
      status.updateErrorMessage(error);
    }
  };

  const onGoogleSignUp = async (user) => {
    try {
      alert(`https://oauth2.googleapis.com/tokeninfo?id_token=${user.tokenId}`);
      onCloseSignUpDialog();
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  };

  const idCotizacion = useMemo(() => {
    const path = location.pathname.split("/");
    const index = path.findIndex((string) => string === "experience-creation");
    if (index >= 0) {
      return path.at(index + 1);
    }
    return null;
  }, [location]);

  const onSubmit = useCallback(async () => {
    try {
      setIsSending(true);
      await API().post("/subscribers", {
        data: { email },
      });
      status.updateSuccessMessage("Tu correo electrónico ha sido añadido");
      setEmail("");
    } catch (error) {
      status.updateErrorMessage(error);
    } finally {
      setIsSending(false);
    }
  }, [email, status]);

  return (
    <div
      className={classNames(styles.container, {
        [styles.embeddedContainer]: isEmbedded,
      })}
      ref={container}>
      {!isEmbedded && (
        <HStack paddingX={10} paddingY={5} backgroundColor={colors.header}>
          <Link
            to={routes.home}
            onClick={(e) => {
              if (idCotizacion && state.isLoggedIn) {
                e.preventDefault();
                onOpen();
              }
            }}>
            <Image image={logo} alt="logo" height={60} width={150} />
          </Link>
          {state.isLoggedIn && (
            <HStack flex={1} marginX={10} space={50}>
              <Link to={routes.tickets}>
                <Heading
                  fontSize="md"
                  color={
                    location.pathname === routes.tickets
                      ? colors.primary
                      : colors.lightGray
                  }>
                  Mis Boletos
                </Heading>
              </Link>
              <Link to={routes.quotations}>
                <Heading
                  fontSize="md"
                  color={
                    location.pathname === routes.quotations
                      ? colors.primary
                      : colors.lightGray
                  }>
                  Mis Cotizaciones
                </Heading>
              </Link>
              <Link to={routes.trips}>
                <Heading
                  fontSize="md"
                  color={
                    location.pathname === routes.trips
                      ? colors.primary
                      : colors.lightGray
                  }>
                  Mis Viajes
                </Heading>
              </Link>
            </HStack>
          )}
          {state.isLoggedIn ? (
            <Link to={routes.profile}>
              <HStack
                space={4}
                backgroundColor="white"
                shadow={1}
                paddingY={2}
                paddingX={5}
                borderRadius={5}>
                <Stack
                  backgroundColor="gray.200"
                  width={10}
                  height={10}
                  borderRadius="full"
                  overflow="hidden"
                  justifyContent="center"
                  alignItems="center"
                  position="relative">
                  {Boolean(state?.user?.photo) && (
                    <Image
                      image={state?.user?.photo}
                      alt="profile"
                      objectFit="cover"
                    />
                  )}
                </Stack>
                <Text>
                  {state.user.firstName} {state.user.lastName}
                </Text>
              </HStack>
            </Link>
          ) : (
            <HStack space={4} flex={1} justifyContent="flex-end">
              <Link
                to={{
                  pathname: routes.signIn,
                  search: qs.stringify(
                    {
                      url: location.pathname === "/" ? null : location.pathname,
                    },
                    { skipNulls: true },
                  ),
                }}>
                <HStack space={1}>
                  <IoMdPerson color={colors.primary} size={30} />
                  <Heading color={colors.primary} fontSize="md">
                    Entrar
                  </Heading>
                </HStack>
              </Link>
              <Pressable
                borderWidth={1}
                borderColor={colors.secondary}
                borderRadius={10}
                paddingX={5}
                paddingY={3}
                onPress={onOpenSignUpDialog}>
                <Heading fontSize="md" color={colors.secondary}>
                  Regístrate
                </Heading>
              </Pressable>
            </HStack>
          )}
        </HStack>
      )}
      <Outlet />
      {!isEmbedded && (
        <VStack marginTop={10}>
          <HStack
            backgroundColor={colors.lighterGray}
            paddingX={5}
            paddingY={10}
            alignItems="flex-start">
            <VStack flex={1} space={2}>
              <Text bold fontSize="lg">
                Autotur
              </Text>
              <Link to={routes.tickets}>
                <Text fontSize="md">Mis Boletos</Text>
              </Link>
              <Link to={routes.quotations}>
                <Text fontSize="md">Mis Cotizaciones</Text>
              </Link>
              <Link to={routes.trips}>
                <Text fontSize="md">Mis Viajes</Text>
              </Link>
            </VStack>
            <VStack flex={1} space={2}>
              <Text bold fontSize="lg">
                Redes <br /> Sociales
              </Text>
              <HStack space={3}>
                {/* TODO: Connect with firebase remote config */}
                <a
                  href="https://www.facebook.com/AutoturMex"
                  target="_blank"
                  rel="noopener noreferrer">
                  <FiFacebook size={25} />
                </a>
                <a
                  href="https://www.instagram.com/autoturmex"
                  target="_blank"
                  rel="noopener noreferrer">
                  <FiInstagram size={25} />
                </a>
                <a
                  href="https://twitter.com/Autotur"
                  target="_blank"
                  rel="noopener noreferrer">
                  <RiTwitterXFill size={25} />
                </a>
                <a
                  href="https://www.youtube.com/@autoturmx1706"
                  target="_blank"
                  rel="noopener noreferrer">
                  <FiYoutube size={25} />
                </a>
              </HStack>
            </VStack>
            <VStack flex={1} space={2}>
              <Text bold fontSize="lg">
                Atención a clientes
              </Text>
              <HStack>
                {/* TODO: Connect with firebase remote config */}
                <a
                  href="https://hola.turibusride.mx/hc/es"
                  target="_blank"
                  rel="noopener noreferrer">
                  <Image
                    image={logoHola}
                    alt="logo_hola"
                    width={150}
                    height={65}
                  />
                </a>
              </HStack>
            </VStack>
            <VStack flex={1} space={2}>
              <Text bold fontSize="lg">
                Recibe nuestras noticias
              </Text>
              <form
                className={styles.form}
                onSubmit={(event) => {
                  event.preventDefault();
                  onSubmit().then(() => event.target.reset());
                }}>
                <HStack backgroundColor={colors.white} borderRadius={5}>
                  <input
                    disabled={isSending}
                    type="email"
                    placeholder="Correo electrónico"
                    className={styles.input}
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <button disabled={isSending}>
                    <Stack
                      alignSelf="stretch"
                      justifyContent="center"
                      paddingX={1}>
                      <MdKeyboardArrowRight size={25} />
                    </Stack>
                  </button>
                </HStack>
                <label className={styles.checkbox}>
                  <input disabled={isSending} type="checkbox" required />
                  <Text fontSize="xs">
                    Acepto términos y condiciones y el aviso de privacidad.
                  </Text>
                </label>
              </form>
            </VStack>
          </HStack>
          <HStack
            backgroundColor={colors.third}
            paddingX={10}
            paddingY={5}
            space={10}>
            <Text color={colors.white} flex={1}>
              ©TURITOUR, 2023. Todos los derechos reservados.
            </Text>
            <a
              href="/aviso_de_privacidad.pdf"
              target="_blank"
              rel="noopener noreferrer">
              <Text underline color={colors.white}>
                Aviso de Privacidad
              </Text>
            </a>
            <a
              href="/terminos_y_condiciones.pdf"
              target="_blank"
              rel="noopener noreferrer">
              <Text underline color={colors.white}>
                Términos y Condiciones
              </Text>
            </a>
          </HStack>
        </VStack>
      )}
      <Modal isOpen={isOpenSignUpDialog} onRequestClose={onCloseSignUpDialog}>
        <VStack padding={5}>
          <Heading fontSize="lg" textAlign="center" color={colors.gray}>
            Regístrate en
            <br />
            Autotur
          </Heading>
          <Spacer height={7} />
          <Pressable
            backgroundColor={colors.facebook}
            color={colors.white}
            borderRadius={30}
            onPress={onFacebookSignUp}
            disabled={isLoading}>
            <HStack justifyContent="center" minH={45} space={2}>
              <FaFacebookF size={20} />
              <Text bold color={colors.white}>
                Facebook
              </Text>
            </HStack>
          </Pressable>
          <Spacer height={5} />
          <GoogleLogin
            clientId="430546055165-bjagl3hjkgjc6pu9gvim8n1n0reip04d.apps.googleusercontent.com"
            render={(renderProps) => (
              <Pressable
                backgroundColor={colors.white}
                borderRadius={30}
                borderWidth={2}
                borderColor={colors.lightGray}
                onPress={() => {
                  setIsLoading(true);
                  renderProps.onClick();
                }}
                disabled={renderProps.disabled || isLoading}>
                <HStack justifyContent="center" minH={41} space={2}>
                  <Image image={google} alt="google" height={20} width={20} />
                  <Text bold>Google</Text>
                </HStack>
              </Pressable>
            )}
            onSuccess={onGoogleSignUp}
            cookiePolicy="single_host_origin"
          />
          <Spacer height={5} />
          <Link to={routes.signUp} disabled={isLoading}>
            <HStack
              backgroundColor={colors.mail}
              color={colors.white}
              borderRadius={30}
              justifyContent="center"
              minH={45}
              space={2}>
              <FiMail size={20} />
              <Text bold color={colors.white}>
                Correo electrónico
              </Text>
            </HStack>
          </Link>
          <Spacer height={5} />
          <Text
            fontSize="sm"
            color={colors.gray}
            lineHeight="sm"
            textAlign="center">
            Al crear una cuenta, muestras tu conformidad con nuestros Términos
            de Servicio y Política de Privacidad.
          </Text>
          <HStack space={3} marginY={5}>
            <Divider flex={1} />
            <Text color={colors.gray}>O</Text>
            <Divider flex={1} />
          </HStack>
          <Link to={routes.signUpVendor} disabled={isLoading}>
            <HStack
              backgroundColor={colors.primary}
              color={colors.white}
              borderRadius={30}
              justifyContent="center"
              minH={45}
              space={2}>
              <Text bold color={colors.white}>
                Registrarse como proveedor
              </Text>
            </HStack>
          </Link>
          <Spacer height={5} />
          <Link to={routes.signIn} disabled={isLoading}>
            <HStack justifyContent="center">
              <Text bold>¿Ya tienes cuenta? Iniciar sesión</Text>
            </HStack>
          </Link>
        </VStack>
      </Modal>
      <Modal maxWidth={700} isOpen={isOpen} onRequestClose={onClose}>
        <VStack paddingX={10} paddingY={8} space={5}>
          <Heading color={colors.secondary} fontSize="2xl">
            Estás a punto de salir de tu cotización
          </Heading>
          <Divider backgroundColor={colors.primary} />
          <Text>
            Al salir de tu cotizacion la información de tu viaje quedará
            quardada en el módulo de cotizaciones con el folio #{idCotizacion},
            tu cotización expirará una vez finalizada la fecha de inicio de tu
            viaje
          </Text>
          <HStack space={5}>
            <button className={styles.flex} onClick={onClose}>
              <Box
                backgroundColor={colors.primary}
                paddingY={3}
                paddingX={50}
                borderRadius="full">
                <Text color={colors.white} textAlign="center">
                  Regresar
                </Text>
              </Box>
            </button>
            <Link className={styles.flex} to={routes.home} onClick={onClose}>
              <Box
                backgroundColor={colors.white}
                paddingY={3}
                paddingX={50}
                borderRadius="full">
                <Text color={colors.primary} textAlign="center">
                  Salir de la cotización
                </Text>
              </Box>
            </Link>
          </HStack>
        </VStack>
      </Modal>
    </div>
  );
}

export default MainLayout;
